import { AuthService } from '../services/auth.service';

// Envuelve el fetch nativo del navegador para que cualquier respuesta 401
// (en rutas que no sean de /auth/) cierre la sesion y redirija a /login.
// Necesario porque varios componentes admin usan fetch() directo en vez de
// HttpClient, por lo que NO pasan por el HttpInterceptor de Angular.
// Se instala una sola vez al arrancar la app (ver app.ts / appConfig).
export function instalarFetch401Handler(auth: AuthService): void {
  const fetchOriginal = window.fetch.bind(window);

  window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const res = await fetchOriginal(...args);

    try {
      const url = typeof args[0] === 'string'
        ? args[0]
        : (args[0] instanceof Request ? args[0].url : String(args[0]));
      const esAuthUrl = url.includes('/auth/');

      if (res.status === 401 && !esAuthUrl && auth.isAuthenticated()) {
        auth.logout(true);
      }
    } catch {
      // si algo falla al inspeccionar, no interrumpimos la respuesta
    }

    return res;
  };
}
